module.exports = __webpack_public_path__ + "img/candidates-reply.9db40a68.svg";